import React, { useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, ScrollView } from 'react-native';

import NavBar from './navBar';
import MenuPanel from './menuPanel';

const FaqPage = () => {
  const [menuVisible, setMenuVisible] = useState(false);
  const toggleMenu = () => setMenuVisible(!menuVisible);
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqSections = [
    {
      title: "Spedizioni",
      questions: [
        { question: "Quanto tempo impiega la spedizione?", answer: "La spedizione Standard impiega generalmente 5-7 giorni lavorativi; quella Premium impiega 1-2 giorni lavorativi, quella Locker 3-4 giorni lavorativi" },
        { question: "Le spedizioni sono gratuite?", answer: "Le spedizioni Standard e Locker sono gratuite, quelle Premium hanno un costo di 10,00 €" },
      ],
    },
    {
      title: "Prodotti",
      questions: [
        { question: "I prodotti sono di alta qualità?", answer: "Sì, tutti i nostri prodotti sono selezionati per qualità e durabilità." },
        { question: "Come posso scegliere la taglia giusta?", answer: "Consulta la nostra guida alle taglie nella pagina di ogni prodotto." },
        { question: "Offrite prodotti in edizione limitata?", answer: "Sì, pubblichiamo regolarmente collezioni a edizione limitata." },
      ],
    },
    {
      title: "Resi e Rimborsi",
      questions: [
        { question: "Come posso restituire un prodotto?", answer: "Puoi restituire un prodotto entro 30 giorni dalla ricezione. Contatta il nostro servizio clienti per assistenza." },
        { question: "Posso ricevere un rimborso?", answer: "Sì, una volta elaborato il reso, riceverai un rimborso sul metodo di pagamento originale." },
        { question: "Quali sono le condizioni per effettuare un reso?", answer: "Gli articoli devono essere inutilizzati e restituiti nella confezione originale." },
      ],
    },
    {
      title: "Pagamenti e Contatti",
      questions: [
        { question: "Quali metodi di pagamento accettate?", answer: "Accettiamo carte di credito, PayPal e altri metodi sicuri." },
        { question: "Come posso contattare il servizio clienti?", answer: "Puoi contattarci via email a neveroutshop@gmail.com o tramite il nostro modulo di contatto." },
      ],
    },
  ];

  return (
    <View style={styles.container}>
      {/* Barra di navigazione con bottone menu */}
      <NavBar toggleMenu={toggleMenu} />

      {/* Menu laterale */}
      <MenuPanel isVisible={menuVisible} onClose={() => setMenuVisible(false)} />

      <ScrollView style={styles.content}>
        <Text style={styles.title}>Domande Frequenti (FAQ)</Text>

        {faqSections.map((section, index) => (
          <View key={index} style={styles.section}>
            <Text style={styles.sectionTitle}>{section.title}</Text>
            {section.questions.map((item, idx) => (
              <View key={idx} style={styles.questionContainer}>
                <TouchableOpacity onPress={() => toggleAnswer(`${index}-${idx}`)} style={styles.questionButton}>
                  <Text style={styles.questionText}>{item.question}</Text>
                </TouchableOpacity>
                {activeIndex === `${index}-${idx}` && (
                  <View style={styles.answerContainer}>
                    <Text style={styles.answerText}>{item.answer}</Text>
                  </View>
                )}
              </View>
            ))}
          </View>
        ))}
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    overflow: 'hidden',
    flex: 1,
    backgroundColor: '#FAFAFA',
  },
  content: {
    flex: 1,
    marginTop: 60,
    padding: 16,
    backgroundColor: '#FFFFFF',
  },
  title: {
    fontSize: 24,
    fontWeight: '700',
    textAlign: 'center',
    marginBottom: 20,
    color: '#333',
  },
  section: {
    marginBottom: 25,
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    padding: 15,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: '600',
    marginBottom: 15,
    color: '#444',
  },
  questionContainer: {
    marginBottom: 12,
  },
  questionButton: {
    padding: 12,
    backgroundColor: '#EEF3F7',
    borderRadius: 6,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  questionText: {
    fontSize: 16,
    fontWeight: '500',
    color: '#333',
  },
  answerContainer: {
    padding: 12,
    backgroundColor: '#F9F9F9',
    borderRadius: 6,
    marginTop: 5,
  },
  answerText: {
    fontSize: 14,
    color: '#555',
  },
});

export default FaqPage;
